import { render } from "./sidepanel.vue?vue&type=template&id=ae332b6c&scoped=true"
import script from "./sidepanel.vue?vue&type=script&lang=js"
export * from "./sidepanel.vue?vue&type=script&lang=js"

import "./sidepanel.vue?vue&type=style&index=0&id=ae332b6c&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae332b6c"]])

export default __exports__